import { TypedAnalyticsEvent } from "@omni/types/components/tracking/analyticsEvent";
import { AvailableInStoreTrackingInfo } from "@omni/types/components/tracking/tracking-info/feature/availableInStore.trackingInfo";

import { GoogleAnalyticsEvents } from "../GoogleAnalyticsEvents";
import {
    GoogleAnalyticsMinimumDataset,
    getPageInfo,
    getUserInfo
} from "../GoogleAnalyticsMinimumDataset";

export interface GoogleAnalyticsAvailableInStoreToggleImpression
    extends GoogleAnalyticsMinimumDataset {
    info: { name: string; storeId?: string };
}

const getGoogleAnalyticsAvailableInStoreToggleImpression = (
    data: TypedAnalyticsEvent<AvailableInStoreTrackingInfo>
): GoogleAnalyticsAvailableInStoreToggleImpression => {
    return {
        event: data.payload.eventData.on
            ? GoogleAnalyticsEvents.ToggleAvailableInStoreOn
            : GoogleAnalyticsEvents.ToggleAvailableInStoreOff,
        pageInfo: getPageInfo(data),
        userInfo: getUserInfo(data),
        info: {
            name: data?.payload.eventData?.name,
            storeId: data?.payload.eventData?.storeId
        }
    };
};

export { getGoogleAnalyticsAvailableInStoreToggleImpression };
